<template>
  <div>
    <v-card class="rounded-lg" flat>
      <v-card-title class="px-10 pt-8">
        <p>{{ $t("organization.details.payment_reminder.title") }}</p>
      </v-card-title>
      <v-divider />
      <v-card-text class="ml-8">
        <v-checkbox
          v-model="warningLocal"
          :label="$t('warning_popup.pop_up')"
          color="#2661FF"
          @change="setWarning()"
        ></v-checkbox>
        <v-checkbox
          v-if="warningLocal !== null && warningLocal !== false"
          v-model="warningOptionsLocal.permanent"
          :label="$t('warning_popup.permanent')"
          color="#2661FF"
          @change="setWarning()"
        ></v-checkbox>
      </v-card-text>
      <v-divider />
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "organizationPaymentReminder",
  data() {
    return {
      warningLocal: null,
      warningOptionsLocal: {
        permanent: false
      }
    };
  },
  created() {
    this.warningLocal = this.warning;
    this.warningOptionsLocal = this.warning_options || { permanent: false };
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      warning: ({ organization: { organization } }) => organization.warning,
      warning_options: ({ organization: { organization } }) =>
        organization.warning_options
    })
  },
  methods: {
    ...mapActions({
      setWarningPayment: "organization/setWarningPayment"
    }),
    async setWarning() {
      await this.setWarningPayment({
        orgId: this.organization.id,
        warning: this.warningLocal,
        warning_options: this.warningOptionsLocal
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
